'use client';

import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormSection from './FormSection';
import FormField from './FormField';
import RadioOption from './RadioOption';
import TextInput from './TextInput';
import SelectInput from './SelectInput';
import type { RSVPFormData } from './RSVPPageClient';

const afterWeddingOptions = [
  { value: 'home', label: "I\'ll return home directly from Warud" },
  { value: 'stay', label: "I\'ll stay in Warud" },
  { value: 'nagpur', label: "I\'ll travel to Nagpur" },
  { value: 'airport', label: "I\'ll travel to Nagpur Airport" },
  { value: 'pickup', label: 'Someone will pick me up' },
  { value: 'own', label: "I\'ll make my own arrangements" },
  { value: 'undecided', label: 'Not decided yet' },
];

const cabOptions = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
  { value: 'maybe', label: 'Maybe' },
];

export default function Section8AfterWedding() {
  const { register } = useFormContext<RSVPFormData>();

  return (
    <FormSection
      number={8}
      title="After the Wedding"
      description="We may arrange shared transportation from Warud to Nagpur after the wedding, including Nagpur Airport."
    >
      <FormField label="What are your plans after the wedding?">
        <div className="grid gap-2 mt-1">
          {afterWeddingOptions.map((opt) => (
            <RadioOption
              key={`after-wedding-${opt.value}`}
              name="afterWedding"
              value={opt.value}
              label={opt.label}
              registerProps={register('afterWedding')}
            />
          ))}
        </div>
      </FormField>

      <FormField label="Would you like to use a shared cab arranged by #Vimi from Warud to Nagpur?">
        <div className="grid gap-2 mt-1">
          {cabOptions.map((opt) => (
            <RadioOption
              key={`warud-nagpur-cab-${opt.value}`}
              name="warudNagpurCab"
              value={opt.value}
              label={opt.label}
              registerProps={register('warudNagpurCab')}
            />
          ))}
        </div>
      </FormField>

      <FormField
        label="Where would you need to be dropped in Nagpur?"
        htmlFor="nagpurDrop"
      >
        <SelectInput
          id="nagpurDrop"
          registerProps={register('nagpurDrop')}
        >
          <option value="">Select drop point</option>
          <option value="Nagpur Airport">✈️ Nagpur Airport</option>
          <option value="Nagpur Railway Station">
            🚆 Nagpur Railway Station
          </option>
          <option value="Nagpur Bus Stand">🚌 Nagpur Bus Stand</option>
          <option value="Other">Other</option>
        </SelectInput>
      </FormField>

      <FormField
        label="What date do you plan to travel from Warud?"
        htmlFor="nagpurTravelDate"
      >
        <SelectInput
          id="nagpurTravelDate"
          registerProps={register('nagpurTravelDate')}
        >
          <option value="">Select travel date</option>
          <option value="4 January 2027">4 January 2027</option>
          <option value="5 January 2027">5 January 2027</option>
          <option value="Other">Other</option>
        </SelectInput>
      </FormField>

      <FormField
        label="If travelling to Nagpur Airport, what is your flight departure time?"
        htmlFor="flightTime"
        helper="Leave blank if not applicable"
      >
        <TextInput
          id="flightTime"
          type="time"
          registerProps={register('flightTime')}
        />
      </FormField>

      <FormField
        label="If travelling by train/bus from Nagpur, what is your departure time?"
        htmlFor="nagpurDepartureTime"
        helper="Leave blank if not applicable"
      >
        <TextInput
          id="nagpurDepartureTime"
          type="time"
          registerProps={register('nagpurDepartureTime')}
        />
      </FormField>
    </FormSection>
  );
}